import { render, staticRenderFns } from "./rewardAndPRecordDetail.vue?vue&type=template&id=47ef18bd&scoped=true&"
import script from "./rewardAndPRecordDetail.vue?vue&type=script&lang=js&"
export * from "./rewardAndPRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./rewardAndPRecordDetail.vue?vue&type=style&index=0&id=47ef18bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef18bd",
  null
  
)

component.options.__file = "rewardAndPRecordDetail.vue"
export default component.exports